/** @format */
import {
    desktop,
    largeDesktop,
    largeTablet,
} from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

import { StyledProductComparisonDisplayProps } from './types';

/* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = ({
    $productIds,
}: StyledProductComparisonDisplayProps) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    width: 100%;
    margin-top: var(--layout-spacing-24);
    margin-bottom: var(--layout-spacing-24);

    .product-comparison-display-heading {
        margin: 0 var(--layout-spacing-32) var(--layout-spacing-8);
        text-align: center;
    }

    .product-comparison-display-link {
        margin: 0 var(--layout-spacing-32) var(--layout-spacing-48);
        text-align: center;

        svg {
            font-size: 1.2rem;
            margin-left: var(--layout-spacing-4);
            margin-top: var(--layout-spacing-2);
        }
    }

    .product-comparison-display-constrainer-wrapper {
        width: 100%;
        min-height: 0;
    }

    .product-comparison-display-scrollable-container {
        height: 100%;
        width: 100%;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

    .product-comparison-display-list {
        display: grid;
        grid-template-columns: 0 repeat(
                ${$productIds.length},
                minmax(28rem, 1fr)
            );
        grid-auto-flow: column;
    }
    ${largeTablet(css`
        margin-bottom: 0;
    `)}

    ${desktop(css`
        .product-comparison-display-list {
            grid-template-columns: auto repeat(
                    ${$productIds.length},
                    minmax(28rem, 1fr)
                );
        }

        .product-comparison-display-scrollable-container {
            width: 100%;
            overflow: auto;
        }
    `)}

    ${largeDesktop(css`
        .product-comparison-display-scrollable-container {
            padding-bottom: var(--layout-spacing-72);
        }
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
